import React, { createContext, useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import qs from 'qs';

import { NotifContext } from './NotifContext';

const blogAPI = process.env.REACT_APP_API;

export const ExploreContext = createContext();

const ExploreContextProvider = (props) => {
  const query = qs.parse(props.location.search.slice(1));
  const [users, setUsers] = useState(new Array(0));
  const [usersLoader, setUsersLoader] = useState(false);
  const [activeTab, setActiveTab] = useState(query.tab || 'friends');
  const [followingLoader, setFollowingLoader] = useState(false);
  const { show } = useContext(NotifContext);
  const [searchContent, setSearchContent] = useState({
    show: false,
    results: {
      articles: [],
      users: [],
    },
  });

  const config = { withCredentials: true };

  const availableTabs = ['friends', 'following', 'followers', 'global'];

  const fetchTopUsers = (tab) => {
    setUsersLoader(true);
    const pointer = users.length || 0;
    const api = `${blogAPI}/u/explore?pointer=${pointer}&type=${tab}`;
    if (localStorage.getItem('loggedin') === 'true') {
      axios
        .get(api, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            // error notif
            show('info', 'Error!', response.message, 'topLeft');
          } else {
            // show('success','Success!',`${response.message}`,'topLeft');
            setUsers(response.payload);
          }
          setUsersLoader(false);
        })
        .catch((e) => {
          console.log(e);
          mixpanel.track('Error: Fetch top users', {
            api,
            has_token: Boolean(config.headers.Authorization),
          });
          show(
            'error',
            'Error!',
            'Something went wrong fetching users!',
            'bottomLeft'
          );
          setUsersLoader(false);
        });
    } else {
      show(
        'info',
        'Privileged Access Only',
        `You must login to use this feature!`,
        'topLeft'
      );
    }
  };

  const followUser = (uid) => {
    mixpanel.track('Clicked follow button');
    setFollowingLoader(true);
    const api = `${blogAPI}/u/subscribe/${uid}`;
    if (localStorage.getItem('loggedin') === 'true') {
      axios
        .get(api, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            // error notif
            show('info', 'Error!', response.message, 'topLeft');
          } else {
            for (let i = 0; i < users.length; i += 1) {
              if (users[i].app_profile_uid === uid) {
                users[i].user.current_user_follows = response.subscribed;
              }
            }
          }
          setFollowingLoader(false);
        })
        .catch((e) => {
          console.log(e);
          mixpanel.track('Error: Follow user', {
            api,
            has_token: Boolean(config.headers.Authorization),
          });
          show('error', 'Error!', 'Something went wrong!', 'topLeft');
          setFollowingLoader(false);
        });
    } else {
      show(
        'info',
        'Privileged Access Only',
        `You must login to use this feature!`,
        'topLeft'
      );
      localStorage.setItem('loggedin', false);
      setFollowingLoader(false);
    }
  };

  const fetchSearchResults = (searchTerms) => {
    const api = `${blogAPI}/articles/search?q=${searchTerms}`;
    if (localStorage.getItem('loggedin') === 'true') {
      axios
        .get(api, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            // error notif
            show('info', 'Error!', response.message, 'topLeft');
          } else {
            // show('success','Success!',`${response.message}`,'topLeft');
            setSearchContent({
              ...searchContent,
              results: { articles: response.payload.articles },
            });
          }
          setUsersLoader(false);
        })
        .catch((e) => {
          console.log(e);
          mixpanel.track('Error: Fetch top users', {
            api,
            has_token: Boolean(config.headers.Authorization),
          });
          show(
            'error',
            'Error!',
            'Something went wrong fetching users!',
            'bottomLeft'
          );
          setSearchContent({ ...searchContent, results: [] });
          setUsersLoader(false);
        });
    } else {
      show(
        'info',
        'Privileged Access Only',
        `You must login to use this feature!`,
        'topLeft'
      );
    }
  };

  // reflects changes from the tabs to the url
  const updateUrlTabValue = (tab) => {
    props.history.push({
      pathName: 'explore',
      search: `?tab=${tab}`,
    });
  };

  // reflects changes from the url to tabs
  useEffect(() => {
    if (availableTabs.includes(query.tab)) {
      setActiveTab(query.tab);
    }
    fetchTopUsers(activeTab);
  }, [activeTab]);

  return (
    <ExploreContext.Provider
      value={{
        users,
        setUsers,
        usersLoader,
        setUsersLoader,
        fetchTopUsers,
        followUser,
        followingLoader,
        setFollowingLoader,
        activeTab,
        setActiveTab,
        updateUrlTabValue,
        searchContent,
        setSearchContent,
        fetchSearchResults,
      }}
    >
      {props.children}
    </ExploreContext.Provider>
  );
};

export default withRouter(ExploreContextProvider);
